<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Good Time Coming</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<p class="dedication"><em>For Samantha, Danielle, and Steve.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1d6ea46b